import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { actions } from './slice';
import { AxiosResponse } from 'axios';
import { NewsTopicsCategoryInterface } from '../types';
import { SelectPageNo, SelectPageSize, SelectSearch, SelectSortColumn, SelectSortDir, selectNewsCategoryForm } from './selector';
import {
  doAddNewsCategory,
  doDeleteNewsCategory,
  doGetNewsCategoryById,
  doGetNewsCategoryList,
  doUpdateNewsCategory,
  doGetNewsCategoryAllList
} from 'utils copy/request';
import { openSnackbar } from 'store/reducers/snackbar';
import CatchBlockFunction from 'hooks/CatchBlockFunction';

export function* AddNewsCategoryRequest(action: { payload: { callback: any } }) {
  yield delay(500);

  const form: NewsTopicsCategoryInterface = yield select(selectNewsCategoryForm);
  if (form.title.length == 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please enter title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }

  try {
    const response: AxiosResponse = yield call(doAddNewsCategory, form);
    if (response && !response.data.statusCode) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: true
      })
    );
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* getNewsCategoryListRequest() {
  yield delay(500);

  try {
    const pageNo: number = yield select(SelectPageNo);
    const pageSize: number = yield select(SelectPageSize);
    const searchText: string = yield select(SelectSearch);
    const SortColumn: string = yield select(SelectSortColumn);
    const SortDir: string = yield select(SelectSortDir);
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      doGetNewsCategoryList,
      `?pageNo=${pageNo}&pageSize=${pageSize}${searchText.length > 0 ? '&search=' + searchText : ''}${
        SortColumn.length > 0 ? '&sortColumn=' + SortColumn : ''
      }${SortDir.length > 0 ? '&sortDir=' + SortDir : ''}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.status) {
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      });
      return;
    }
    yield put(actions.setTotalRow(response.data.meta ? response.data.meta.total : 0));
    yield put(actions.setNewsCategoryList(response.data.results));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* getNewsCategoryAllListRequest() {
  yield delay(500);

  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(doGetNewsCategoryAllList);
    yield put(actions.setLoading(false));
    if (response && !response.status) {
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      });
      return;
    }

    yield put(actions.setNewsCategoryAllList(response.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doNewsDeleteRequest(action: { payload: { id: string; callback: any } }) {
  yield delay(500);
  if (action.payload.id.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'Select Blog to delete',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return;
  }
  try {
    const response: AxiosResponse = yield call(doDeleteNewsCategory, action.payload.id);

    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: false
        })
      );

      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: false
      })
    );
    yield put(action.payload.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* getNewsCategoryPackageById(action: { payload: string }) {
  yield delay(500);
  if (action.payload.length === 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'Select User',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return;
  }
  try {
    const response: AxiosResponse = yield call(doGetNewsCategoryById, action.payload);

    if (response && !response.data) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: false
        })
      );

      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: false
      })
    );

    yield put(actions.setNewsCategoryForEdit(response.data.data));
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* doUpdateNewsCategoryRequest(action: { payload: { callback: any } }) {
  yield delay(500);
  const form: NewsTopicsCategoryInterface = yield select(selectNewsCategoryForm);
  if (form.title.length == 0) {
    yield put(
      openSnackbar({
        open: true,
        message: 'please enter title',
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: true
      })
    );
    return;
  }
  try {
    const response: AxiosResponse = yield call(doUpdateNewsCategory, form);
    if (response && !response.data.statusCode) {
      yield put(
        openSnackbar({
          open: true,
          message: response.data.message,
          variant: 'alert',
          alert: {
            color: 'error'
          },
          close: true
        })
      );
      return;
    }
    yield put(
      openSnackbar({
        open: true,
        message: response.data.message,
        variant: 'alert',
        alert: {
          color: 'success'
        },
        close: true
      })
    );
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}
export function* NewsTopicsCategoryRepoSaga() {
  yield takeLatest(actions.AddNewsCategory, AddNewsCategoryRequest);
  yield takeLatest(actions.doGetNewsCategoryList, getNewsCategoryListRequest);
  yield takeLatest(actions.doGetNewsCategoryAllList, getNewsCategoryAllListRequest);
  yield takeLatest(actions.doNewsCategoryDelete, doNewsDeleteRequest);
  yield takeLatest(actions.doNewsCategoryEdit, getNewsCategoryPackageById);
  yield takeLatest(actions.doUpdateNewsCategory, doUpdateNewsCategoryRequest);
}
